import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import { addFriendAnimationToSprite, getFriendFrameName } from '../AnimationManager';
import SpritePool from '../common/SpritePool';
import Bubble from '../game/Bubble';

export default class BubbleMaker extends Phaser.GameObjects.Container {
  /**
   * 
   * @param {Phaser.Scene} scene 
   */
  constructor(scene, spritename) {
    super(scene);

    this.spritename = spritename;

    this.itemType = 'BubbleMaker';

    this.waiter = 0;
    this.waitTime = Phaser.Math.Between(2,8) / 10;

    this.isActive = true;

    this.bottomHandle = this.scene.add.sprite(0,0, ABCyaPhaser.Images.DEFAULT_ATLAS, getFriendFrameName(this.spritename));
    this.bottomHandle.x = -this.bottomHandle.width / 2;
    this.bottomHandle.y = -this.bottomHandle.height / 2;
    this.add(this.bottomHandle);
    addFriendAnimationToSprite(this.bottomHandle,this.spritename);
    this.bubblePool = new SpritePool(this.scene, Bubble, 200);
    this.activeBubbles = [];
    this.once(Phaser.GameObjects.Events.DESTROY, () => this.bubblePool.cleanup());

    ABCyaPhaser.Container.setContainerInteractive(this);
    this.scene.input.setDraggable(this, true);
  }

  prepareForRemove () {
    this.isActive = false;
    this.bottomHandle.alpha = 0;
  }

  makeBubble () {
    const item = this.bubblePool.getSprite();
    const scale = Phaser.Math.Between(10,100) / 100;
    const speed = Phaser.Math.Between(80,140);
    item.reset(Phaser.Math.Between(this.x - 10, this.x + 10), this.y, scale, speed);
    this.scene.add.existing(item);
    this.scene.children.bringToTop(item);
    this.activeBubbles.push(item);
  }

  returnBubble (i) {
    this.scene.children.remove(this.activeBubbles[i]);
    this.bubblePool.returnSprite(this.activeBubbles[i]);
    this.activeBubbles.splice(i,1);
  }

  getHitRect () {
    const w = this.getBounds().width;
    const h = this.getBounds().height;
    const rect = new Phaser.Geom.Rectangle(this.x - w / 2, this.y - h / 2, w, h);
    return rect;
  }

  tick (delta) {
    const len = this.activeBubbles.length - 1; let item = null;
    for (let i = len; i >= 0; i--) {
      item = this.activeBubbles[i];
      if (item.y < 0) {
        this.returnBubble(i);
      }
      else {
        item.tick(delta);
      }
    }

    if (!this.isActive) {
      if (this.activeBubbles.length === 0) {
        this.emit('BUBBLES_DONE');
      }
    }
    else {
      if (this.waiter < 0) {
        this.makeBubble();

        this.waitTime = Phaser.Math.Between(2,8) / 10;
        this.waiter = this.waitTime;
      }
      else {
        this.waiter -= 1 * delta;
      }
    }
  }
}